import React from 'react';

import { getIndexForControlsInsideTable } from '../../../utils/form-manager.utils';
import VirtualDynamicField from '../../VirtualDynamicField';

const VirtualSection = ({
  rowIndex,
  index,
  isHidden,
  isViewOnly,
  childrenNodes,
  isParentlessTable,
  containersProps,
  gridIndex,
}) => {
  const gridArrIndex = getIndexForControlsInsideTable(index, rowIndex, isParentlessTable);

  return childrenNodes.map((id) => (
    <VirtualDynamicField
      key={`${id}#${gridArrIndex.join(',')}`}
      id={id}
      index={gridArrIndex}
      isParentHidden={isHidden}
      isParentViewOnly={isViewOnly}
      containersProps={containersProps}
      gridIndex={gridIndex}
    />
  ));
};

export default VirtualSection;
